import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { ref: "embedded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("dialog", {
          ref: "dialogEL",
          class: _normalizeClass(["teaser-overlay-dialog overflow-x-hidden overflow-y-auto bg-white backdrop:bg-black/50", $options.overlayDialogTopMarginContent.class]),
          style: _normalizeStyle($options.overlayDialogTopMarginContent.style),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.handleDialogClick && $options.handleDialogClick(...args)))
        }, [
          _createElementVNode("div", _hoisted_1, null, 512)
        ], 6)
      ]),
      _: 1
    })
  ]))
}